import { useEffect, useState } from "react";
import "../css/funds.css";
import membersImg from "../assets/helps/members.jpg";
import volunteersImg from "../assets/helps/volunteers.avif";
import rationImg from "../assets/helps/ration.jpeg";
import medicalImg from "../assets/helps/medical.png";
import financialImg from "../assets/helps/financial.png";
import schoolImg from "../assets/helps/schoolfees.png";
import marriageImg from "../assets/helps/marriage.jpeg";
import aqiqahImg from "../assets/helps/aqiqah.jpg";
import islamicClassImg from "../assets/helps/islamicclass.avif";
import EventImg from "../assets/helps/event.jpg";
import donorImg from "../assets/helps/donorImg.webp";
import sadqaboxImg from "../assets/helps/sadqaboximg.jpg";

export default function Funds() {
  const [animatedCounts, setAnimatedCounts] = useState({});

  const items = [
    { key: "members", label: "Members", cnt: 11, img: membersImg },
    { key: "volunteers", label: "Volunteers", cnt: 12, img: volunteersImg },
    { key: "rationHelp", label: "Ration Help", cnt: 76, img: rationImg },
    { key: "medicalHelp", label: "Medical Help", cnt: 23, img: medicalImg },
    {
      key: "financialHelp",
      label: "Financial Help",
      cnt: 10,
      img: financialImg,
    },
    {
      key: "schoolFeesHelp",
      label: "School Fees Help",
      cnt: 13,
      img: schoolImg,
    },
    { key: "marriageHelp", label: "Marriage Help", cnt: 1, img: marriageImg },
    { key: "akikahQurbani", label: "Akikah Qurbani", cnt: 2, img: aqiqahImg },
    { key: "madrasa", label: "Islamic Class", cnt: 1, img: islamicClassImg },
    { key: "event", label: "Event", cnt: 2, img: EventImg },
    { key: "total-donors", label: "Donors", cnt: 7, img: donorImg },
    { key: "sadqabox", label: "sadqaBox", cnt: 60, img: sadqaboxImg },
  ];

  // Animated counter (using static values)
  useEffect(() => {
    items.forEach((item) => {
      let start = 0;
      const end = item.cnt;
      const duration = 3000;
      const increment = Math.ceil(end / (duration / 20));

      const counter = setInterval(() => {
        start += increment;
        if (start >= end) {
          start = end;
          clearInterval(counter);
        }

        setAnimatedCounts((prev) => ({
          ...prev,
          [item.key]: start,
        }));
      }, 20);
    });
  }, []);

  return (
    <div className="funds">
      <div className="funds-container">
        <div className="funds-row">
          {items.map((item) => (
            <div className="fund-card" key={item.key}>
              <img src={item.img} alt="icon" className="fund-icon" />
              <div className="facts-text">
                <h3>{animatedCounts[item.key] || 0}</h3>
                <p>{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
